export function checkNullOrEmpty(string: string | undefined | null) {
  return string ? string : undefined
}
